export const ROUTES = {
	// Auth routes
	home: "/",
	login: "/login",
	register: "/register",
	forgotPassword: "/forgot-password",
	setPassword: "/setpassword/:token",
	resetPassword: "/resetpassword/:token",
	setMfa: "/setmfa",
	invoiceCreatorRegister: "creator/register",
	invoicePayerRegister: "payer/register",
	invoiceLogin: "invoice/login",
	verifyOtp: "verify-otp",
	ivaltInstruction: "ivalt-setup-instructions",
	verifyIvalt: "/verify-ivalt",

	// Dashboard routes
	dashboard: "/dashboard",
	details: "/details",
	payment: "/payment",
	onboarding: "/onboarding",
	paymentSettingRead: "/paymentsettingread",

	// Payment related routes
	createPayment: "/createpayment",
	createPaymentTest: "/createpaymenttest",
	bulkPayment: "/bulkpayment",
	addPaymentFields: "/addpaymentfields",
	submitPayment: "/submitpayment",
	bulkPaymentSpreadsheet: "/bulkpaymentspreadsheet",
	bulkPaymentList: "/bulkpaymentlist",
	paymentConfiguration: "/paymentconfiguration",

	// Admin routes
	adminCompliance: "/admin/compliance",

	// Feature routes
	transactions: "/transactions",
	// transactionDetails: "/transaction-details/:paymentId",
	transactionDetails: "/transaction-details",
	users: "/users",
	fraudScreen: "/fraudscreen",
	checkQuotes: "/checkquotes",
	facilitator: "/facilitator",
	developerResources: "/developerresources",
	fxRate: "/fxrate",
	reports: "/reports",
	profile: "/profile",
	riskProfile: "/riskprofile",
	profileDetails: "/profiledetails",
	ledger: "/ledger",
	batchResend: "/batch-resend",
	batchResendConfirm: "/batch-confirm",
	creatorProfile: "/creator/profile",
	creatorInvoiceList: "/creator/invoice-list",
	creatorInvoice: "/creator/create-invoice",
	manualCreateInvoice: "/creator/manual-invoice",
	uploadInvoice: "/creator/upload-invoice",
	payerInvoiceList: "/payer/invoice-list",
	payerInvoiceReview: "/payer/invoice-review",
	invoiceList: "/invoice-list",
	pendingApproval: "/status",
	creatorDashboard: "/creator/dashboard",
	payerDashboard: "/payer/dashboard",
};
